/** ****************Pricing demo.eleve.ai***********************/
// const app = "https://pricing.demo.eleve.ai/";
// const appPath = "https://pricing.demo.eleve.ai/pricing_demo_restapi/";

/** ****************Pricing Demo***********************/
const app = "https://pricing.demo.retailnorthstar.ai/";
const appPath = "https://pricing.demo.retailnorthstar.ai/pricing_demo_restapi/";
const applicationTitle = "Pricing";
const customerBrandName = sessionStorage.getItem('selectedBrandName') ? sessionStorage.getItem('selectedBrandName') : "RetailNortstar.ai";
const customerBrandNameShort = "RN";
const customerLogoPath = sessionStorage.getItem('selectedLogo') ? sessionStorage.getItem('selectedLogo') : "Brandlogo.png";
const customerBrandNotPlayingColor = "#fb7777";
const customerBrandSmallerSelectionColor = "#009FB7";
const displayTestPortFolioInUserMenu = "No";
const isDemoApp = "no"; // keep lowercase always
const isExcelAppSupported = "yes";
const xlApps = "Silos";
const imagePathReg = "https://mediasvr.sohum.tech/ciimages/ciregularimages/";
const imagePathSmall = "https://mediasvr.sohum.tech/ciimages/cismallimages/";
const imagePathThumb = "https://mediasvr.sohum.tech/ciimages/cithumbnailimages/";
const otherBrandPremiumSelectionColor = "#d9a201";
const smImagePathReg = "https://mediasvr.sohum.tech/ciimages/socialmedia/";
const smLogosPathReg = "https://mediasvr.sohum.tech/ciimages/brandlogos/";
const templateInstruction = "https://mediasvr.sohum.tech/ciimages/xltemplate/linelist.png";
const sendFeedbackTo = "analytics@sohumtechin.com";
const sentimentPositiveColor = "#009FB7";
const sentimentNegativeColor = "#fb7777";
const sentimentNeutralColor = "#FED766";
const sleep = 1000;
const YesWeAre = false; //  false will disable test modules;
const brandLogoUrl = "https://mediasvr.sohum.tech/ciimages/brandlogos/";
export {
  app,
  appPath,
  applicationTitle,
  customerBrandName,
  customerLogoPath,
  customerBrandNameShort,
  customerBrandNotPlayingColor,
  customerBrandSmallerSelectionColor,
  displayTestPortFolioInUserMenu,
  isExcelAppSupported,
  isDemoApp,
  imagePathReg,
  imagePathSmall,
  imagePathThumb,
  smImagePathReg,
  smLogosPathReg,
  sendFeedbackTo,
  sentimentPositiveColor,
  sentimentNegativeColor,
  sentimentNeutralColor,
  sleep,
  otherBrandPremiumSelectionColor,
  YesWeAre,
  templateInstruction,
  xlApps,
  brandLogoUrl
};
